import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from "vue";
import { artifactStore, viewApiStore, documentStore } from "@/hooks";
import { List, ListItem, PanelCard } from "@/components/common";


/**
 * Displays the selected node's views.
 */
const __default__ = {
  name: "ArtifactViews",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const artifact = computed(() => artifactStore.selectedArtifact);

const documents = computed(() =>
  artifact.value
    ? documentStore.projectDocuments.filter(
        ({ documentId }) => artifact.value?.documentIds.includes(documentId)
      )
    : []
);

const doDisplay = computed(() => documents.value.length > 0);

return (_ctx: any,_cache: any) => {
  return (doDisplay.value)
    ? (_openBlock(), _createBlock(_unref(PanelCard), {
        key: 0,
        title: "Views",
        collapsable: "",
        borderless: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(List), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value, (doc) => {
                return (_openBlock(), _createBlock(_unref(ListItem), {
                  key: doc.documentId,
                  clickable: "",
                  tooltip: "",
                  title: doc.name,
                  onClick: ($event: any) => (_unref(viewApiStore).handleSwitch(doc))
                }, null, 8, ["title", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})